import { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  GraduationCap, BookOpen, Award, Clock, MapPin, Phone, Mail, 
  ExternalLink, Calendar, Users, CheckCircle, Star, Filter
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../components/ui/dialog';

const CURSOS_DATA = [
  {
    id: 1,
    tipo: "Diplomado",
    nombre: "Diplomado en Gestión Inmobiliaria Profesional",
    descripcion: "Formación integral para profesionales inmobiliarios que desean obtener el rango de Profesional Inmobiliario o avanzar al rango de Máster.",
    duracion: "120 horas",
    modalidad: "Híbrido (Presencial y En línea)",
    institucion: "UPIM - Universidad de Profesionales Inmobiliarios de México",
    rangoAplica: "Profesional Inmobiliario / Máster Inmobiliario",
    precio: "Consultar",
    proximaFecha: "Marzo 2026",
    contacto: { email: "diplomados@upim.mx", telefono: "+52 55 1234 5678" },
    avalado: true,
    destacado: true
  },
  {
    id: 2,
    tipo: "Curso",
    nombre: "Fundamentos del Mercado Inmobiliario",
    descripcion: "Curso básico que cubre los conceptos fundamentales del sector inmobiliario mexicano, marco legal y buenas prácticas.",
    duracion: "20 horas",
    modalidad: "En línea",
    institucion: "AMPI Nacional",
    rangoAplica: "Profesional Inmobiliario",
    precio: "$3,500 MXN",
    proximaFecha: "Permanente",
    contacto: { email: "cursos@ampi.org", telefono: "+52 55 5207 5858" },
    avalado: true,
    destacado: false
  },
  {
    id: 3,
    tipo: "Curso",
    nombre: "Aspectos Legales de las Operaciones Inmobiliarias",
    descripcion: "Marco jurídico aplicable a las transacciones inmobiliarias, contratos, escrituración y aspectos fiscales.",
    duracion: "20 horas",
    modalidad: "En línea",
    institucion: "CANADEVI",
    rangoAplica: "Profesional Inmobiliario",
    precio: "$4,200 MXN",
    proximaFecha: "Permanente",
    contacto: { email: "capacitacion@canadevi.org.mx", telefono: "+52 55 5080 5270" },
    avalado: true,
    destacado: false
  },
  {
    id: 4,
    tipo: "Curso",
    nombre: "Valuación Inmobiliaria Básica",
    descripcion: "Metodologías y técnicas para la valuación de inmuebles residenciales y comerciales.",
    duracion: "15 horas",
    modalidad: "En línea",
    institucion: "UPIM",
    rangoAplica: "Profesional Inmobiliario Avanzado",
    precio: "$2,800 MXN",
    proximaFecha: "Febrero 2026",
    contacto: { email: "cursos@upim.mx", telefono: "+52 55 1234 5678" },
    avalado: true,
    destacado: false
  },
  {
    id: 5,
    tipo: "Curso",
    nombre: "Marketing Digital Inmobiliario",
    descripcion: "Estrategias de marketing digital aplicadas al sector inmobiliario: redes sociales, portales y captación de leads.",
    duracion: "15 horas",
    modalidad: "En línea",
    institucion: "AMPI Nacional",
    rangoAplica: "Profesional Inmobiliario Avanzado",
    precio: "$3,000 MXN",
    proximaFecha: "Permanente",
    contacto: { email: "cursos@ampi.org", telefono: "+52 55 5207 5858" },
    avalado: true,
    destacado: false
  },
  {
    id: 6,
    tipo: "Diplomado",
    nombre: "Diplomado en Desarrollo Inmobiliario",
    descripcion: "Formación especializada en desarrollo de proyectos inmobiliarios: factibilidad, financiamiento y comercialización.",
    duracion: "120 horas",
    modalidad: "Presencial",
    institucion: "ADI - Asociación de Desarrolladores Inmobiliarios",
    rangoAplica: "Máster Inmobiliario",
    precio: "Consultar",
    proximaFecha: "Abril 2026",
    contacto: { email: "academia@adi.org.mx", telefono: "+52 55 5281 3600" },
    avalado: true,
    destacado: true
  },
  {
    id: 7,
    tipo: "Certificación",
    nombre: "Certificación Federal en Competencias Inmobiliarias",
    descripcion: "Certificación oficial ante CONOCER y la SEP que acredita competencias laborales en el sector inmobiliario.",
    duracion: "Evaluación",
    modalidad: "Presencial",
    institucion: "Organismos Certificadores avalados por CONOCER",
    rangoAplica: "Todos los rangos",
    precio: "$8,500 MXN",
    proximaFecha: "Convocatorias mensuales",
    contacto: { email: "info@conocer.gob.mx", telefono: "+52 55 2282 0200" },
    avalado: true,
    destacado: true
  },
  {
    id: 8,
    tipo: "Maestría",
    nombre: "Maestría en Negocios Inmobiliarios",
    descripcion: "Programa de posgrado con enfoque en gestión estratégica de negocios inmobiliarios y desarrollo urbano.",
    duracion: "2 años",
    modalidad: "Presencial",
    institucion: "Universidad Anáhuac",
    rangoAplica: "Máster Inmobiliario Avanzado / Doctor Inmobiliario",
    precio: "Consultar",
    proximaFecha: "Agosto 2026",
    contacto: { email: "posgrados@anahuac.mx", telefono: "+52 55 5627 0210" },
    avalado: true,
    destacado: false
  },
  {
    id: 9,
    tipo: "Licenciatura",
    nombre: "Licenciatura en Administración de Negocios Inmobiliarios",
    descripcion: "Programa universitario completo para formación de profesionales inmobiliarios con reconocimiento oficial de la SEP.",
    duracion: "4 años",
    modalidad: "Presencial / Ejecutiva",
    institucion: "Universidades afiliadas al CNI",
    rangoAplica: "Licenciado Inmobiliario",
    precio: "Consultar por universidad",
    proximaFecha: "Agosto 2026",
    contacto: { email: "info@cni.org.mx", telefono: "+52 55 1234 5678" },
    avalado: true,
    destacado: false
  },
  {
    id: 10,
    tipo: "Curso",
    nombre: "Negociación y Cierre de Ventas Inmobiliarias",
    descripcion: "Técnicas avanzadas de negociación y estrategias para el cierre efectivo de operaciones inmobiliarias.",
    duracion: "15 horas",
    modalidad: "En línea",
    institucion: "UPIM",
    rangoAplica: "Profesional Inmobiliario Avanzado",
    precio: "$2,500 MXN",
    proximaFecha: "Permanente",
    contacto: { email: "cursos@upim.mx", telefono: "+52 55 1234 5678" },
    avalado: true,
    destacado: false
  }
];

const TIPOS = ["Todos", "Curso", "Diplomado", "Certificación", "Licenciatura", "Maestría"];
const RANGOS = ["Todos", "Profesional Inmobiliario", "Profesional Inmobiliario Avanzado", "Licenciado Inmobiliario", "Máster Inmobiliario", "Máster Inmobiliario Avanzado", "Doctor Inmobiliario"];

const CursoCard = ({ curso, onVerDetalle }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg transition-all group" data-testid={`curso-card-${curso.id}`}>
    {curso.destacado && (
      <div className="bg-amber-500 text-white text-xs font-semibold px-4 py-1 flex items-center gap-1">
        <Star className="w-3 h-3" />
        Destacado
      </div>
    )}
    <div className="p-6">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <Badge variant="secondary" className="bg-slate-100 text-slate-700 mb-2">{curso.tipo}</Badge>
          <h3 className="font-manrope font-semibold text-lg text-slate-900 leading-tight group-hover:text-slate-700">
            {curso.nombre}
          </h3>
        </div>
        {curso.avalado && (
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center" title="Avalado por el CNI">
              <CheckCircle className="w-5 h-5 text-green-600" />
            </div>
          </div>
        )}
      </div>
      
      <p className="text-slate-600 text-sm mb-4 line-clamp-2">{curso.descripcion}</p>
      
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <Clock className="w-4 h-4" />
          <span>{curso.duracion}</span>
          <span className="text-slate-300">•</span>
          <span>{curso.modalidad}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <GraduationCap className="w-4 h-4" />
          <span>{curso.institucion}</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Award className="w-4 h-4 text-amber-500" />
          <span className="text-slate-700 font-medium">{curso.rangoAplica}</span>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-slate-100">
        <div>
          <p className="text-xs text-slate-500">Próxima fecha</p>
          <p className="font-semibold text-slate-900">{curso.proximaFecha}</p>
        </div>
        <Button onClick={() => onVerDetalle(curso)} className="bg-amber-500 hover:bg-amber-400 text-black font-bold">
          Ver Detalles
        </Button>
      </div>
    </div>
  </div>
);

const CursoDetailModal = ({ curso, isOpen, onClose }) => {
  if (!curso) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="curso-detail-modal">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="secondary" className="bg-slate-100">{curso.tipo}</Badge>
            {curso.avalado && (
              <Badge className="bg-green-100 text-green-700">
                <CheckCircle className="w-3 h-3 mr-1" />
                Avalado CNI
              </Badge>
            )}
          </div>
          <DialogTitle className="font-manrope text-xl">{curso.nombre}</DialogTitle>
          <DialogDescription className="text-slate-600">
            {curso.descripcion}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 mt-4">
          {/* Info Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="text-xs text-slate-500 mb-1">Duración</p>
              <p className="font-semibold text-slate-900 flex items-center gap-2">
                <Clock className="w-4 h-4 text-slate-400" />
                {curso.duracion}
              </p>
            </div>
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="text-xs text-slate-500 mb-1">Modalidad</p>
              <p className="font-semibold text-slate-900">{curso.modalidad}</p>
            </div>
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="text-xs text-slate-500 mb-1">Precio</p>
              <p className="font-semibold text-slate-900">{curso.precio}</p>
            </div>
            <div className="bg-slate-50 rounded-lg p-4">
              <p className="text-xs text-slate-500 mb-1">Próxima Fecha</p>
              <p className="font-semibold text-slate-900 flex items-center gap-2">
                <Calendar className="w-4 h-4 text-slate-400" />
                {curso.proximaFecha}
              </p>
            </div>
          </div>

          {/* Institution */}
          <div className="bg-slate-900 text-white rounded-lg p-4">
            <p className="text-xs text-slate-400 mb-1">Institución</p>
            <p className="font-semibold text-lg">{curso.institucion}</p>
          </div>

          {/* Rango Aplicable */}
          <div className="border border-amber-200 bg-amber-50 rounded-lg p-4">
            <p className="text-xs text-amber-700 mb-1 font-medium">Rango(s) al que aplica</p>
            <p className="font-semibold text-amber-900 flex items-center gap-2">
              <Award className="w-5 h-5" />
              {curso.rangoAplica}
            </p>
          </div>

          {/* Contact Info */}
          <div className="border border-slate-200 rounded-lg p-4">
            <h4 className="font-semibold text-slate-900 mb-4 flex items-center gap-2">
              <Users className="w-5 h-5 text-slate-400" />
              Información de Contacto
            </h4>
            <div className="space-y-3">
              <a href={`mailto:${curso.contacto.email}`} className="flex items-center gap-3 text-slate-600 hover:text-slate-900 transition-colors">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                  <Mail className="w-5 h-5" />
                </div>
                <span>{curso.contacto.email}</span>
              </a>
              <a href={`tel:${curso.contacto.telefono}`} className="flex items-center gap-3 text-slate-600 hover:text-slate-900 transition-colors">
                <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center">
                  <Phone className="w-5 h-5" />
                </div>
                <span>{curso.contacto.telefono}</span>
              </a>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <Button className="flex-1 bg-amber-500 hover:bg-amber-400 text-black font-bold">
              <Mail className="w-4 h-4 mr-2" />
              Solicitar Información
            </Button>
            <Button variant="outline" onClick={onClose} className="border-slate-300 text-slate-700 hover:bg-slate-100 font-semibold">
              Cerrar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const OfertaAcademicaPage = () => {
  const [filtroTipo, setFiltroTipo] = useState("Todos");
  const [filtroRango, setFiltroRango] = useState("Todos");
  const [busqueda, setBusqueda] = useState("");
  const [cursoSeleccionado, setCursoSeleccionado] = useState(null);

  const cursosFiltrados = CURSOS_DATA.filter(curso => {
    const matchTipo = filtroTipo === "Todos" || curso.tipo === filtroTipo;
    const matchRango = filtroRango === "Todos" || curso.rangoAplica.includes(filtroRango);
    const matchBusqueda = busqueda === "" || 
      curso.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
      curso.institucion.toLowerCase().includes(busqueda.toLowerCase());
    return matchTipo && matchRango && matchBusqueda;
  });

  return (
    <div className="page-transition bg-slate-50 min-h-screen" data-testid="oferta-academica-page">
      {/* Hero */}
      <div className="relative bg-[#111111] overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1762146828422-50a8bd416d3c?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80"
            alt="Planos arquitectónicos"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#111111]/60 to-[#111111]" />
        </div>
        <div className="container-cni relative py-16 md:py-24 text-center">
          <Badge variant="secondary" className="bg-amber-500/20 text-amber-400 border-amber-500/30 mb-6">
            <BookOpen className="w-4 h-4 mr-2" />
            Formación Profesional Avalada
          </Badge>
          <h1 className="font-manrope font-bold text-3xl md:text-5xl text-white mb-6">
            Oferta Académica
          </h1>
          <p className="text-gray-400 max-w-3xl mx-auto text-lg leading-relaxed">
            Descubre los cursos, diplomados, certificaciones y programas académicos avalados por el 
            Colegio Nacional de Inmobiliarios para avanzar en tu carrera profesional.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="container-cni py-8">
        <div className="bg-white border border-slate-200 rounded-xl p-6 mb-8">
          <div className="flex items-center gap-2 text-slate-700 mb-4">
            <Filter className="w-5 h-5" />
            <span className="font-semibold">Filtrar oferta académica</span>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="text-sm text-slate-600 mb-1 block">Buscar</label>
              <Input 
                placeholder="Nombre del curso o institución..."
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
                className="border-slate-200"
                data-testid="search-cursos-input"
              />
            </div>
            <div>
              <label className="text-sm text-slate-600 mb-1 block">Tipo de formación</label>
              <Select value={filtroTipo} onValueChange={setFiltroTipo}>
                <SelectTrigger className="border-slate-200" data-testid="filtro-tipo-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {TIPOS.map(tipo => (
                    <SelectItem key={tipo} value={tipo}>{tipo}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm text-slate-600 mb-1 block">Rango aplicable</label>
              <Select value={filtroRango} onValueChange={setFiltroRango}>
                <SelectTrigger className="border-slate-200" data-testid="filtro-rango-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {RANGOS.map(rango => (
                    <SelectItem key={rango} value={rango}>{rango}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>

        {/* Results */}
        <div className="mb-4">
          <p className="text-slate-600">
            <span className="font-semibold text-slate-900">{cursosFiltrados.length}</span> programas encontrados
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cursosFiltrados.map(curso => (
            <CursoCard key={curso.id} curso={curso} onVerDetalle={setCursoSeleccionado} />
          ))}
        </div>

        {cursosFiltrados.length === 0 && (
          <div className="text-center py-16 bg-white rounded-xl border border-slate-200">
            <BookOpen className="w-12 h-12 text-slate-300 mx-auto mb-4" />
            <h3 className="font-manrope font-semibold text-lg text-slate-900 mb-2">
              No se encontraron programas
            </h3>
            <p className="text-slate-600 mb-4">Intenta ajustar los filtros de búsqueda</p>
            <Button variant="outline" onClick={() => { setFiltroTipo("Todos"); setFiltroRango("Todos"); setBusqueda(""); }} className="border-slate-300 text-slate-700 hover:bg-slate-100 font-semibold">
              Limpiar filtros
            </Button>
          </div>
        )}

        {/* CTA */}
        <div className="mt-16 relative bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src="https://images.unsplash.com/photo-1632433339330-f46c673854c0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80"
              alt="Documentos profesionales"
              className="w-full h-full object-cover opacity-30"
            />
          </div>
          <div className="relative p-8 md:p-12 text-center">
            <h2 className="font-manrope font-bold text-2xl text-white mb-4">
              ¿Tu institución desea ser parte del CNI?
            </h2>
            <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
              Si representas una institución educativa y deseas que tus programas sean avalados 
              por el Colegio Nacional de Inmobiliarios, contáctanos.
            </p>
            <Link to="/contacto">
              <Button className="bg-amber-500 hover:bg-amber-400 text-black font-bold">
                Contactar al CNI
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <CursoDetailModal 
        curso={cursoSeleccionado} 
        isOpen={!!cursoSeleccionado} 
        onClose={() => setCursoSeleccionado(null)} 
      />
    </div>
  );
};
